let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("dYoYq")).then(() => parcelRequire('lxhOA'));